import twitterIcon from "../../../assets/icons/socials/social1.svg";
import linkedinIcon from "../../../assets/icons/socials/social2.svg";
import facebookIcon from "../../../assets/icons/socials/social3.svg";
import githubIcon from "../../../assets/icons/socials/social4.svg";
import dribbbleIcon from "../../../assets/icons/socials/social6.svg";
import instagramIcon from "../../../assets/icons/socials/social7.svg";
import { resolveMediaUrl } from "../../../utils/mediaUrl";

export const SOCIAL_PLATFORM_ICONS = {
  twitter: twitterIcon,
  x: twitterIcon,
  instagram: instagramIcon,
  linkedin: linkedinIcon,
  facebook: facebookIcon,
  github: githubIcon,
  dribbble: dribbbleIcon,
};

/** Default icon by social slot index (matches original footer order). */
export const SOCIAL_INDEX_ICONS = [
  twitterIcon,
  instagramIcon,
  linkedinIcon,
  facebookIcon,
  githubIcon,
  dribbbleIcon,
];

export const SOCIAL_PLATFORM_OPTIONS = [
  { value: "twitter", label: "Twitter / X" },
  { value: "instagram", label: "Instagram" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "facebook", label: "Facebook" },
  { value: "github", label: "GitHub" },
  { value: "dribbble", label: "Dribbble" },
  { value: "custom", label: "Custom" },
];

const LABEL_TO_PLATFORM = {
  "twitter / x": "twitter",
  twitter: "twitter",
  x: "twitter",
  instagram: "instagram",
  linkedin: "linkedin",
  facebook: "facebook",
  github: "github",
  dribbble: "dribbble",
};

export function normalizeSocialPlatform(platform, label = "") {
  const raw = String(platform || "")
    .trim()
    .toLowerCase();
  if (raw && SOCIAL_PLATFORM_ICONS[raw]) return raw;
  if (raw === "custom") return "custom";

  const fromPlatformLabel = LABEL_TO_PLATFORM[raw];
  if (fromPlatformLabel) return fromPlatformLabel;

  const fromLabel = LABEL_TO_PLATFORM[String(label || "").trim().toLowerCase()];
  if (fromLabel) return fromLabel;

  const haystacks = [raw, String(label || "").trim().toLowerCase()];
  for (const haystack of haystacks) {
    if (!haystack) continue;
    for (const option of SOCIAL_PLATFORM_OPTIONS) {
      if (option.value === "custom") continue;
      if (haystack.includes(option.value)) return option.value;
    }
  }

  return raw || "";
}

/**
 * Resolve the icon URL for a social link.
 * Prefers custom upload, then platform preset, then slot index — never collapse all to one icon.
 */
export function resolveSocialIconSrc(social) {
  const custom = String(social?.icon || "").trim();
  if (custom) {
    return resolveMediaUrl(custom) || custom;
  }

  const platform = normalizeSocialPlatform(social?.platform, social?.label);
  if (platform && SOCIAL_PLATFORM_ICONS[platform]) {
    return SOCIAL_PLATFORM_ICONS[platform];
  }

  const index = Number(social?.index);
  if (Number.isFinite(index) && index >= 0) {
    return SOCIAL_INDEX_ICONS[index % SOCIAL_INDEX_ICONS.length];
  }

  return twitterIcon;
}
